import useStyle from "./useStyle";

const useBootstrap = () => useStyle('https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css');
export default useBootstrap;